import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'src/routes/hooks';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import QuarterlyRiskTable from './quaterly-review-table';
const QuaterlyReviewPage = () => {
    const searchParams = useSearchParams();
    const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
    console.log('myToken', token)

    const { id } = useParams();
    const [QuarterlyRiskDetails, setQuarterlyRiskDetails] = useState();  // New state for incident details

    useEffect(() => {
        getQuarterlyRisk();
    }, [])

    const getQuarterlyRisk = async () => {
        const data = await getRequest(endpoints.risk_management.quaterly_review.quaterly_review_Show(id));
        console.log("🚀 ~ getQuarterlyRisk ~ data:", data)
        setQuarterlyRiskDetails(data);

    }
    return (
        <QuarterlyRiskTable data={QuarterlyRiskDetails} />
    );
};
export default QuaterlyReviewPage;